$(document).ready(init())
  

function init() {
  console.log("running miku-cart.js")
  initChangeHandlers()
  getCartAttributes()
}


function initChangeHandlers(){
  $('.numbersOnly').keyup(function () { 
    if (this.value > 5) {
      this.value = 5
    }
    if (this.value) {
      var _tmpVal = this.value
      var updateDict =  {updates: {}}
      $.ajax({
        type: 'GET',
        url: 'http://mikucare.com/cart.json',
        dataType: 'jsonp',
        success: function(data) { 
          data.items.filter(function(item) {
            updateDict['updates'][item.id] = _tmpVal
            $.post('/cart/update.js', updateDict).always(function(data) {window.location.reload()})            
          })
        }
      });    
    }    
  });
}


function incrementValue(itemId) {
  var updateDict =  {updates: {}}
  $.ajax({
    type: 'GET',
    url: 'http://mikucare.com/cart.json',
    dataType: 'jsonp',
    success: function(data) { 
      data.items.filter(function(item) {
        var value =  $('.update_' + item.id).val();
        value = isNaN(value) ? 0 : value;
        value++;
        if (itemId == item.id) {
          updateDict['updates'][item.id] = value
        }
        else {
          updateDict['updates'][item.id] = item.quantity
        }
        $.post('/cart/update.js', updateDict).always(function(data) {window.location.reload()})            
      })
    }
  });
}

function deIncrementValue(itemId) {
  var updateDict =  {updates: {}}
  $.ajax({
    type: 'GET',
    url: 'http://mikucare.com/cart.json',
    dataType: 'jsonp',
    success: function(data) { 
      console.log(data.items);
      data.items.filter(function(item) {
        var value =  $('.update_' + item.id).val();
        value = isNaN(value) ? 0 : value;
        if (value !== 0 ) {value--;}
        if (itemId == item.id) {
          updateDict['updates'][item.id] = value
        }
        else {
          updateDict['updates'][item.id] = item.quantity
        }
        $.post('/cart/update.js', updateDict).always(function(data) {window.location.reload()})         
      })
    }
  });
} 

function getCartAttributes() {
  $.get('/cart.js', function (data, textStatus, jqXHR) { 
    var jsonData = JSON.parse(data)
  	console.log(jsonData.attributes.applyCoupon, textStatus)
    if (jsonData.attributes.applyCoupon == 'true') {
    	
    }
  })
}
